module.exports = __webpack_public_path__ + "media/images/appLogo-98c0dfb086491783e6b1e7b0ec87cdc4.png";